import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { take, tap } from "rxjs/operators";

import { UserService } from "../user.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private userService: UserService) {}

  public canActivate(): Observable<boolean> {
    return this.userService.isAuthenticated.pipe(
      take(1),
      tap((res) => {
        if (!res) {
          this.router.navigate(["/"]);
        }
      })
    );
  }
}
